import { mobioApi } from './clients';
import { removeNullField, getEnv } from '../helpers';
import { KeyValuePair } from '@teko/ui/dist/types';

interface ObjectMap {
  [key: string]: any;
}

const merchantId = getEnv('MOBIO_MERCHANT_ID');
const token = getEnv('MOBIO_TOKEN');

const fieldMap: KeyValuePair = {
  subscribeTags: 'lst_tag_unsubscribe',
  unsubscribeTags: 'lst_tag_unsubscribe_deleted',
  otherReason: getEnv('MOBIO_OTHER_REASON_FIELD'),
};

export const normalizeParams = (params: ObjectMap): ObjectMap => {
  const normalizedParams: ObjectMap = {};
  const mappingFields = Object.keys(fieldMap);
  Object.keys(params).forEach((field) => {
    const data = params[field];
    if (~mappingFields.indexOf(field)) {
      normalizedParams[fieldMap[field]] = data;
    } else {
      normalizedParams[field] = data;
    }
  });
  return normalizedParams;
};

const MOBIO_REQUEST_HEADER = {
  headers: {
    Authorization: `Basic ${token}`,
    Accept: 'application/json, text/plain, */*',
    'Content-Type': 'application/json',
    'X-Merchant-ID': merchantId,
  },
};

export const mobioService = {
  getProfile: (phoneOrEmail: string) => {
    return mobioApi.get('/profiling/v3.0/customers/thirdparty_search_users', {
      params: { query: phoneOrEmail },
      ...MOBIO_REQUEST_HEADER,
    });
  },
  createMobioProfile: (
    customerName: string,
    customerPhone?: string,
    customerEmail?: string,
  ) => {
    const customer = {
      name: customerName,
      phone_number_1: customerPhone,
      email_1: customerEmail,
    };
    return mobioApi.post(
      `/profiling/v3.0/merchants/${merchantId}/customers/actions/create`,
      {
        customer,
      },
      MOBIO_REQUEST_HEADER,
    );
  },
  updateProfile(
    customerId: string,
    customerName?: string,
    customerPhone?: string,
    customerEmail?: string,
  ) {
    const customer = removeNullField({
      name: customerName,
      phone_number_1: customerPhone,
      email_1: customerEmail,
    });
    return mobioApi.patch(
      `/profiling/v3.0/merchants/${merchantId}/customers/actions/update/${customerId}`,
      {
        customer,
      },
      MOBIO_REQUEST_HEADER,
    );
  },
  updateMobioTags: (
    customerId: string,
    subscribeTags: string[],
    unsubscribeTags: string[],
    otherReason?: string,
  ) => {
    return mobioApi.put(
      `/profiling/v3.0/df/profile/${customerId}/unsubscribe`,
      {
        ...normalizeParams({ subscribeTags, unsubscribeTags, otherReason }),
      },
      MOBIO_REQUEST_HEADER,
    );
  },
};
